import { render, staticRenderFns } from "./InvalidityReasons.vue?vue&type=template&id=87f96ac2"
import script from "./InvalidityReasons.vue?vue&type=script&lang=js"
export * from "./InvalidityReasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports